package com.iregained.eventapp.components.sections.event_details.styles

import com.iregained.eventapp.utils.Res
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val SocialProofSectionStyle = CssStyle {
    base {
        Modifier
            .width(100.percent)
            .padding(topBottom = 4.cssRem) // Increased padding for breathing room
            .backgroundColor(Res.IRColors.SurfaceContainerLow)
            .borderBottom(1.px, LineStyle.Solid, Res.IRColors.OutlineVariant)
    }
}

// NEW: Inner container to center content
val SocialProofLogoStyle = CssStyle {
    base {
        Modifier
            .height(size = 100.px) // Keeps all logos at a uniform height
            .margin(leftRight = 30.px, topBottom = 15.px)
            // Turns logos gray and slightly transparent by default
            .styleModifier { property("filter", "grayscale(0%) opacity(80%)") }
            .transition(
                Transition.of("filter", 0.3.s),
                Transition.of("transform", 0.3.s)
            )
    }
    hover {
        Modifier
            // Restores full color and opacity on hover
            .styleModifier { property("filter", "grayscale(0%) opacity(100%)") }
            .scale(1.05) // Soft pop effect
    }
}
